import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { EditableColumnDef, EditableTable } from "../../../../../shared/components/table/inline-edit-table";
import { CustomSelect, CustomTextField } from "../../../../../shared/components/inputfields/form-elements";
import { StyledButton } from "../../../../../shared/components/buttons/custom-button";
import { dtrackItService } from "../../../../transaction-certificates/tc-service/dtrackit.service";
import useNotification from "../../../../../shared/hooks/useNotification";
import { useTransactionCertificateStore } from "../../../../../store/transaction-certificates.store";
import { Utills } from "../../../../../shared/app-configs/utilit";
import { ComponentDetails } from "../../../sc-models/facility-product-details-dto";

export interface ComponentRawMaterialDetails {
  productComponentNo:string;
  componentRawMaterialCode: string; // Text field
  componentRawMaterialPercentage: string | null; // Numeric field or null
}

interface RawMaterialsInfoProps {
  rawMaterialInfoData: ComponentRawMaterialDetails[];
  componentData : ComponentDetails[],
  setRawMaterialInfoData: React.Dispatch<React.SetStateAction<ComponentRawMaterialDetails[]>>;
}

// Define Yup validation schema for each row


const CompoenentRawMaterialDetailsForm: React.FC<RawMaterialsInfoProps> = ({
  rawMaterialInfoData,
  setRawMaterialInfoData,
  componentData
}) => {
  const [data, setData] = useState<ComponentRawMaterialDetails[]>(rawMaterialInfoData.filter((rmd)=>componentData?.map(({productComponentNo})=>productComponentNo)?.includes(rmd?.productComponentNo)));
  const [tableData, setTableData] = useState<ComponentRawMaterialDetails[]>(rawMaterialInfoData.filter((rmd)=>componentData?.map(({productComponentNo})=>productComponentNo)?.includes(rmd?.productComponentNo)));
  const [editingRowIndex, setEditingRowIndex] = useState<number>(-1);
  const [rawMaterials, setRawMaterials] = useState<any[]>([]);
  const { notify } = useNotification()
  const { isRestrictPopUpSave, setRestrictPopUpSave } = useTransactionCertificateStore();


  // valid values are BLANK, 56, 50-100
  const validationSchema = Yup.object().shape({
    componentRawMaterialCode: Yup.string().required("Raw Material Code is required"),
    componentRawMaterialPercentage: Yup.string()
    .nullable()
    // .test(
    //   'percentage-validation',
    //   'Total percentage cannot exceed 100',
    //   function(value) {
    //     if (!value) return true;
        
    //     // If current value is a range, skip validation
    //     if (value.includes('-')) return true;

    //     // Calculate total of only pure numbers
    //     if (editingRowIndex > -1) {
    //       const total = data.reduce((sum, item, index) => {
    //         if (index === editingRowIndex) return sum;
            
    //         const percentage = item.componentRawMaterialPercentage;
    //         // Only add to total if it's a pure number (not a range)
    //         if (percentage && typeof percentage === 'string' && !percentage.includes('-')) {
    //           return sum + parseFloat(percentage);
    //         }
    //         return sum;
    //       }, 0);

    //       const currentValue = parseFloat(value);
    //       if ((total + currentValue) > 100) {
    //         notify("Raw Material Percentage cannot be greater than 100", "error");
    //         return false;
    //       }
    //     }
    //     return true;
    //   }
    // ),
  });
  useEffect(() => {
    const getRawMaterialCodes = async () => {
      try {
        const result: any = await dtrackItService.getRawMaterialCodes()

        Utills.cl(`result getProductDetails ${JSON.stringify(result)}`)

        const rawMaterials = result.data.map((t: any) => ({ value: t.code_1, label: `${t.description_1} (${t.code_1})` }))
        Utills.cl(`rawMaterials ${JSON.stringify(rawMaterials)}`)
        setRawMaterials(rawMaterials);
      } catch (err) {
        Utills.cl(`Error in Fetching Organic Farm Standard Code ${err}`)
      }
    };
    getRawMaterialCodes()
  }, [])

  const formik = useFormik<ComponentRawMaterialDetails>({
    initialValues: {
      productComponentNo:"",
      componentRawMaterialCode: "",
      componentRawMaterialPercentage: null,
    },
    validationSchema,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: () => {
      // Submission logic if needed
    },
  });

  const handleCellChange = (rowIndex: number, columnId: string, value: any) => {
    formik.setFieldValue(columnId, value);
    setData((prevData) =>
      prevData.map((row, index) =>
        index === rowIndex ? { ...row, [columnId]: value } : row
      )
    );
  };

  const handleAddNewRow = () => {
    const newRow: ComponentRawMaterialDetails = {
      productComponentNo:"",
      componentRawMaterialCode: "",
      componentRawMaterialPercentage: null,
    };
    setData((prevData) => [...prevData, newRow]);
    setEditingRowIndex(data.length);
    setRestrictPopUpSave(true)
    formik.setValues(newRow);
    formik.setTouched({});
  };

  const handleCancelEdit = async () => {
    // const currentRowValues = formik.values;

    // // Determine if the row being edited is new by comparing `editingRowIndex` with the data length
    // const isNewRow = editingRowIndex === data.length - 1;

    // try {
    //   // Validate the row using the Formik validation schema
    //   await validationSchema.validate(currentRowValues, { abortEarly: false });

    //   if (isNewRow) {
    //     // If validation passes and it's a new row, keep it in the data
    //     setData((prevData) => prevData.map((row, index) => (index === editingRowIndex ? currentRowValues : row)));
    //   } else {
    //     // If it's an existing row, revert changes
    //     formik.setValues(data[editingRowIndex]);
    //   }
    // } catch (validationErrors) {
    //   if (isNewRow) {
    //     // If validation fails and it's a new row, remove it from the data
    //     setData((prevData) => prevData.slice(0, -1));
    //   } else {
    //     // If it's an existing row, revert changes
    //     formik.setValues(data[editingRowIndex]);
    //   }
    // }
    setData(tableData);
    setRestrictPopUpSave(false);
    // Reset editing state and form
    setEditingRowIndex(-1);
    formik.resetForm();
  }

  const handleSaveRow = () => {
    // if (editingRowIndex === null || !formik.isValid) return;

    if (editingRowIndex === null || !formik.isValid) {
      console.log('Formik validation state:', {
          isValid: formik.isValid,
          errors: formik.errors,
          touched: formik.touched,
          values: formik.values
      });
      return;
    }
    const updatedRow = formik.values;
    const newData = data.map((row, index) =>
        index === editingRowIndex ? updatedRow : row
      );
    setData(newData);
    setTableData(newData);
    setRawMaterialInfoData(newData); // Update parent state
    setRestrictPopUpSave(false)
    setEditingRowIndex(-1);
    formik.resetForm();
  };

  const columns: EditableColumnDef<ComponentRawMaterialDetails>[] = [
    {
      accessorKey: "productComponentNo",
      header: "Product Component No.",
      renderEditCell: ({ value, onChange }) => (
        <CustomSelect
          label=""
          name="productComponentNo"
          value={value}
          options={componentData?.map((comp)=>{
            return {
              label:comp?.productComponentNo,
              value:comp?.productComponentNo,
            }
          })}
          onChange={(e) => onChange(e.target.value)}
        />
      ),
    },
    {
      accessorKey: "componentRawMaterialCode",
      header: "Component Raw Material Code",
      renderEditCell: ({ value, onChange }) => (
        <CustomSelect
          label=""
          name="componentRawMaterialCode"
          value={value}
          options={rawMaterials}
          enableSearch={true}
          onChange={(e) => onChange(e.target.value)}
        />
      ),
    },
    {
      accessorKey: "componentRawMaterialPercentage",
      header: "Component Raw Material Percentage",
      renderEditCell: ({ value, onChange }) => (
        <CustomTextField
          name="componentRawMaterialPercentage"
          value={value}
          type="text"
          sx={{ mb: 2 }}
          inputProps={{ max: 100 }}
          onChange={(e) => {
            const newValue = e.target.value;
            // if (!newValue || (Number(newValue) <= 100 && /^[0-9]*$/.test(newValue))) { onChange(newValue) }
            if (!newValue || /^(100|[1-9]?[0-9])(-([1-9]?[0-9]|100)?)?$/.test(newValue)) {
              console.log("newValue", newValue);
              onChange(newValue);
            }
          }
          }
          placeholder="Enter percentage"
        />
      ),
    },
  ];

  const handleEditRow = (rowIndex: number) => {
    setEditingRowIndex(rowIndex);
    setRestrictPopUpSave(true);
    formik.setValues(data[rowIndex]);
  };

  const handleDeleteRow = (rowIndex: number) => {
    const updatedData = data.filter((_, index) => index !== rowIndex);
    setData(updatedData);
    setTableData(updatedData);
    setRawMaterialInfoData(updatedData); // Update parent state
  };

  return (
    <div>
      <Box
        component="main"
        sx={{ flexGrow: 1, p: 1, border: "2px solid rgba(128, 128, 128, .2)", my: 4 }}
      >
        <Box display="flex" mb={3} justifyContent="flex-end" width="100%">
          <StyledButton disabled={!formik.isValid || isRestrictPopUpSave} onClick={handleAddNewRow} sx={{ mb: 2 }}>
            Add Product Component Raw Material
          </StyledButton>
        </Box>
        <EditableTable
          data={data}
          columns={columns}
          onSaveRow={handleSaveRow}
          onCellChange={handleCellChange}
          editingRowIndex={editingRowIndex}
          onEditRow={handleEditRow}
          onCancelEdit={handleCancelEdit}
          onDeleteRow={handleDeleteRow}
          enablePagination = {false}
        />
      </Box>
    </div>
  );
};

export default CompoenentRawMaterialDetailsForm;
